<template>
    <div>
        <div v-if="project">
            <well>
                <div class="flex flex-col lg:flex-row justify-between mb-6">
                    <h1 class="text-3xl font-bold text-gray-900">{{ project.title }}</h1>
                    <div class="text-gray-600">
                        <!-- <div class="mb-1">Posted on {{ project.created_at }}</div>
                        <div v-if="project.expiry_date_diff_in_days < 0">
                            <span class="text-red-500 font-semibold">Expired</span>-
                            <span>{{ project.expiry_date }}</span>
                        </div>
                        <div v-if="project.expiry_date_diff_in_days > 0">
                            <span class="text-teal-500 font-semibold capitalize">{{ project.state.description }}</span> -
                            <span>{{ project.expiry_date_diff_in_days }} days left</span>
                        </div> -->
                    </div>
                </div>
                <div class="flex flex-col lg:flex-row lg:items-end justify-between">
                    <div class="flex space-x-10 text-lg">
                        <div>
                            <div class="text-gray-600 mb-1">Winning Bid</div>
                            <div class="font-bold text-teal-500">{{ project.winning_bid | formattedCurrency }}</div>
                        </div>
                        <div>
                            <div class="text-gray-600 mb-1">Posted On</div>
                            <div class="font-bold text-teal-500">{{ project.published_at }}</div>
                        </div>
                    </div>
                    <div class="mt-6 lg:mt-0">
                        <FinishProject v-if="project.can_auth_add_review" :project="project" @finished="fetchProject" />
                    </div>
                </div>
            </well>
            <div class="mt-8 grid grid-cols-1 lg:grid-cols-6 gap-6">
                <chat-box :project="project" />
                <div class="relative lg:col-span-2 rounded-lg bg-white shadow-lg hover:shadow-xl overflow-hidden">
                    <div class="px-6 py-4">
                        <h2 class="text-2xl font-bold text-teal-600">Project Files</h2>
                    </div>
                    <hr />
                    <div class="px-6 py-6 overflow-y-auto overflow-x-hidden" style="height: 500px;padding-bottom: 150px;">
                        <div>
                            <div v-if="projectAttachments">
                                <div v-for="(attachment, index) in projectAttachments" :key="index" class="my-1">
                                    <a
                                        class="link-primary"
                                        :href="`/projects/${project.slug}/attachments/${attachment.id}/download`"
                                        ><i class="fa fa-paperclip"></i> {{ attachment.file_name }}</a
                                    >
                                    <span
                                        class="ml-2 text-xs text-blue-500 cursor-pointer"
                                        @click="removeAttachment(attachment.id, index)"
                                        >Remove</span
                                    >
                                </div>
                            </div>
                            <p v-else>No files have been uploaded.</p>
                        </div>
                    </div>
                    <div
                        v-if="attachments.length < 50"
                        class="p-4 flex flex-wrap space-x-5 absolute bottom-0 right-0 left-0 bg-gray-100"
                    >
                        <form v-if="form" class="w-full" @submit.prevent="submitForm" @input="onFormChange">
                            <multiple-attachments
                                ref="attachments"
                                type="murtaza"
                                label="Add Attachments (Private)"
                                :max-file-size="10"
                                :help-text="'You can upload files with extensions including png, jpg, pdf, xls, and doc format'"
                            >
                                <template #submitButton>
                                    <my-button :loading="submitting" class="btn btn-primary py-1" type="submit">
                                        <span class="fa fa-upload"></span> Upload
                                    </my-button>
                                </template>
                            </multiple-attachments>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FinishProject from './FinishProject';
import Form from '../../forms/form';
export default {
    components: { FinishProject },
    props: {
        projectSlug: {
            type: String,
            required: true
        },
        attachments: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            form: new Form(
                {
                    attachments: []
                },
                { hasFiles: true, withFormData: true }
            ),
            submitting: false,
            projectAttachments: this.attachments,
            project: null
        };
    },

    created() {
        this.fetchProject();
    },

    methods: {
        fetchProject() {
            axios.get(`/api/projects/${this.projectSlug}`).then(response => {
                this.project = response.data.data;
            });
        },
        submitForm() {
            this.submitting = true;
            this.form.attachments = this.$refs.attachments.files.map(file => file.file);

            this.form
                .post(`/api/projects/${this.project.slug}/add-attachments`)
                .then(response => {
                    this.projectAttachments = response.data.data;
                    flash.success();
                })
                .catch(() => {
                    if (this.form.errors.any()) {
                        flash.error({ message: 'It seems like you have submitted invalid data.' });
                        return;
                    }

                    flash.error();
                })
                .finally(() => {
                    this.submitting = false;
                    this.$refs.attachments.files = [];
                });
        },
        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        },
        removeAttachment(mediaId, index) {
            axios
                .delete(`/api/projects/${this.project.slug}/media/${mediaId}/remove-attachment`)
                .then(() => {
                    flash.success();
                    this.projectAttachments.splice(index, 1);
                })
                .catch(() => flash.error());
        }
    }
};
</script>
